import { render, staticRenderFns } from "./bigdataanalyticsapplicationtypeSystem.vue?vue&type=template&id=68f8fb50&scoped=true"
import script from "./bigdataanalyticsapplicationtypeSystem.vue?vue&type=script&lang=js"
export * from "./bigdataanalyticsapplicationtypeSystem.vue?vue&type=script&lang=js"
import style0 from "./bigdataanalyticsapplicationtypeSystem.vue?vue&type=style&index=0&id=68f8fb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f8fb50",
  null
  
)

export default component.exports